import { computed, ref, watch } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ba395fd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "modal-title"
};
const _hoisted_2 = {
  class: "ok-btn-wrap"
};
const _hoisted_3 = {
  class: "form-field"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "field-label"
}, "目标层级", -1));
const _hoisted_5 = {
  class: "form-field"
};
const _hoisted_6 = {
  class: "field-head"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "field-label"
}, "粘贴国家代码或名称", -1));
const _hoisted_8 = ["href"];
const _hoisted_9 = {
  class: "field-head"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "field-label"
}, "粘贴国家代码或名称", -1));
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  key: 2,
  class: "error-list"
};
const _hoisted_13 = {
  key: 3,
  class: "error-list"
};
import { message } from 'ant-design-vue';
import { DeliveredProcedureOutlined, FileTextOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'QuickImportModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    // 渠道（apple / google），决定对照表链接
    prodChnl: {
      type: String,
      default: ''
    },
    // 有效层级选项 [{label,value}]
    tierOptions: {
      type: Array,
      default: () => []
    },
    // 国家全集（用于 Mock 识别匹配），来自本地价格表
    countries: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:open', 'confirm'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    // 标准国家/Code 对照表（飞书文档），按渠道区分
    const REF_TABLE_URL = {
      apple: 'https://ewe8txd9jt.feishu.cn/wiki/FVRUwiM7GigidDkoximcVqh6ndd?from=from_copylink',
      google: 'https://ewe8txd9jt.feishu.cn/wiki/LkpwwrdAtiRshvkwMUrcFTednGd?from=from_copylink'
    };
    const refTableUrl = computed(() => props.prodChnl === 'apple' ? REF_TABLE_URL.apple : REF_TABLE_URL.google);
    const modeOptions = [{
      label: '按单一层级录入',
      value: 'single'
    }, {
      label: '多层级匹配导入(Excel)',
      value: 'excel'
    }];
    const mode = ref('single');
    const targetTierCode = ref('');
    // 两个模式各自独立的输入框，互不串值
    const singleText = ref('');
    const excelText = ref('');
    const loading = ref(false);
    const unrecognized = ref([]);
    const invalidLevels = ref([]);
    // 当前模式对应的输入框文本（按钮禁用/提交取值用）
    const activeText = computed(() => mode.value === 'single' ? singleText.value : excelText.value);
    const levelValues = computed(() => props.tierOptions.map(o => o.value));
    // 外部无国家/地区（层级默认价未生成本地价格表）时禁用识别分配
    const noCountries = computed(() => !props.countries.length);
    // 目标层级兜底：为空或已不在有效层级（如所选层级被删除）时重置为第一项
    watch(() => [props.open, props.tierOptions], () => {
      if (props.open && !levelValues.value.includes(targetTierCode.value)) {
        targetTierCode.value = levelValues.value[0] || 'T1';
      }
    }, {
      immediate: true
    });
    const resetState = () => {
      singleText.value = '';
      excelText.value = '';
      unrecognized.value = [];
      invalidLevels.value = [];
    };
    // 切换模式：错误提示是针对某次提交的，换模式即清掉
    watch(mode, () => {
      unrecognized.value = [];
      invalidLevels.value = [];
    });
    // 国家识别索引：代码、名称都建小写键 → 同一国家。用于「名称/代码任取一个匹配」
    const buildResolver = () => {
      const map = new Map();
      props.countries.forEach(c => {
        map.set(c.regionCode.toLowerCase(), c);
        map.set(c.regionName.toLowerCase(), c);
      });
      return map;
    };
    const splitLines = text => text.split(/\n+/).map(s => s.trim()).filter(Boolean);
    // Excel 模板表头行（region_name/region_code/等级）跳过
    const isHeaderLine = line => /region_name|region_code/i.test(line);
    const TIER_RE = /^T\d+$/i;
    // 单一层级：忽略等级列，名称/代码任取一个识别国家。
    // 整块复制（含 Tab）的行只取一个国家；手输的逗号/空格列表每个 token 都是国家
    const parseSingleCodes = text => {
      const resolver = buildResolver();
      const codes = [];
      const unrecognized = [];
      splitLines(text).forEach(line => {
        if (isHeaderLine(line)) return;
        if (line.includes('\t')) {
          const cells = line.split('\t').map(s => s.trim()).filter(Boolean);
          // 忽略等级 cell，名称/代码取第一个匹配上的
          const hit = cells.map(c => resolver.get(c.toLowerCase())).find(Boolean);
          if (hit) codes.push(hit.regionCode);else unrecognized.push(cells.find(c => !TIER_RE.test(c)) || cells[0]);
        } else {
          line.split(/[,，\s]+/).map(s => s.trim()).filter(Boolean).forEach(tok => {
            const hit = resolver.get(tok.toLowerCase());
            if (hit) codes.push(hit.regionCode);else unrecognized.push(tok);
          });
        }
      });
      return {
        codes: [...new Set(codes)],
        unrecognized: [...new Set(unrecognized)]
      };
    };
    // 多层级：每行取等级（匹配 T\d 的 cell）+ 名称/代码任取一个识别国家。等级为空的行跳过不分配
    const parseExcelPairs = text => {
      const resolver = buildResolver();
      const validSet = new Set(levelValues.value);
      const pairs = [];
      const unrecognized = [];
      const invalidLevels = [];
      splitLines(text).forEach(line => {
        if (isHeaderLine(line)) return;
        const cells = (line.includes('\t') ? line.split('\t') : line.split(/[,，\t\s]+/)).map(s => s.trim()).filter(Boolean);
        if (!cells.length) return;
        const tierCell = cells.find(c => TIER_RE.test(c));
        const tierCode = tierCell ? tierCell.toUpperCase() : '';
        if (!tierCode) return; // 等级为空 → 跳过该行（不分配）
        const hit = cells.map(c => resolver.get(c.toLowerCase())).find(Boolean);
        if (!hit) {
          unrecognized.push(cells.find(c => !TIER_RE.test(c)) || cells[0]);
          return;
        }
        if (!validSet.has(tierCode)) {
          invalidLevels.push(tierCode);
          return;
        }
        pairs.push({
          regionCode: hit.regionCode,
          tierCode
        });
      });
      return {
        pairs,
        unrecognized: [...new Set(unrecognized)],
        invalidLevels: [...new Set(invalidLevels)]
      };
    };
    const onSubmit = () => {
      if (!activeText.value.trim()) {
        message.warning('请先粘贴录入内容');
        return;
      }
      loading.value = true;
      unrecognized.value = [];
      invalidLevels.value = [];
      try {
        if (mode.value === 'single') {
          const {
            codes,
            unrecognized: un
          } = parseSingleCodes(singleText.value);
          if (un.length) {
            unrecognized.value = un;
            return; // 有未识别则拦截不写回
          }
          if (!codes.length) {
            message.warning('未识别到有效国家/地区');
            return;
          }
          emit('confirm', {
            mode: 'single',
            tierCode: targetTierCode.value,
            codes
          });
          message.success(`成功识别并分配 ${codes.length} 个国家/地区`);
          onCancel();
        } else {
          const {
            pairs,
            unrecognized: un,
            invalidLevels: bad
          } = parseExcelPairs(excelText.value);
          if (un.length || bad.length) {
            unrecognized.value = un;
            invalidLevels.value = bad;
            return;
          }
          if (!pairs.length) {
            message.warning('未识别到有效国家/地区');
            return;
          }
          emit('confirm', {
            mode: 'excel',
            pairs
          });
          message.success(`成功识别并分配 ${pairs.length} 个国家/地区`);
          onCancel();
        }
      } finally {
        loading.value = false;
      }
    };
    const onCancel = () => {
      resetState();
      emit('update:open', false);
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_segmented = _resolveComponent("a-segmented");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        width: 440,
        onCancel: onCancel
      }, {
        title: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_unref(DeliveredProcedureOutlined), {
          class: "title-icon"
        }), _createTextVNode(" 快捷录入国家 ")])]),
        footer: _withCtx(() => [_createVNode(_component_a_button, {
          onClick: onCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_tooltip, {
          title: _unref(noCountries) ? '请先填写层级默认价生成国家/地区列表' : ''
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_a_button, {
            type: "primary",
            loading: loading.value,
            disabled: _unref(noCountries) || !_unref(activeText).trim(),
            onClick: onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode(" 识别并分配 ")]),
            _: 1
          }, 8, ["loading", "disabled"])])]),
          _: 1
        }, 8, ["title"])]),
        default: _withCtx(() => [_createVNode(_component_a_segmented, {
          value: mode.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => mode.value = $event),
          options: modeOptions,
          block: "",
          class: "mode-seg"
        }, null, 8, ["value"]), mode.value === 'single' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_select, {
          value: targetTierCode.value,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => targetTierCode.value = $event),
          options: __props.tierOptions
        }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("a", {
          class: "ref-link",
          href: _unref(refTableUrl),
          target: "_blank",
          rel: "noopener noreferrer"
        }, [_createVNode(_unref(FileTextOutlined), {
          class: "ref-link-icon"
        }), _createTextVNode("查看标准国家/Code对照表 ")], 8, _hoisted_8)]), _createVNode(_component_a_textarea, {
          value: singleText.value,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => singleText.value = $event),
          rows: 6,
          placeholder: "支持逗号、空格、换行，例如：USA,JPY,KOR 或者 美国 日本…"
        }, null, 8, ["value"])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("a", {
          class: "ref-link",
          href: _unref(refTableUrl),
          target: "_blank",
          rel: "noopener noreferrer"
        }, [_createVNode(_unref(FileTextOutlined), {
          class: "ref-link-icon"
        }), _createTextVNode("查看标准国家/Code对照表 ")], 8, _hoisted_11)]), _createVNode(_component_a_textarea, {
          value: excelText.value,
          "onUpdate:value": _cache[3] || (_cache[3] = $event => excelText.value = $event),
          rows: 6,
          placeholder: "例如：\n美国 USA T1\n法国 FRA T2\n巴西 BRA T3"
        }, null, 8, ["value"])], 64)), unrecognized.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, "未识别国家/地区：" + _toDisplayString(unrecognized.value.join('、')), 1)) : _createCommentVNode("", true), invalidLevels.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 无效层级：" + _toDisplayString(invalidLevels.value.join('、')) + "（仅支持 " + _toDisplayString(_unref(levelValues).join('/')) + "） ", 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["open"]);
    };
  }
});